import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import CTASection from './components/CTASection';
import EEATSection from './components/EEATSection';
import ArticlesSection from './components/ArticlesSection';
import MoreArticlesGrid from './components/MoreArticlesGrid';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <CTASection />
        <EEATSection />
        <ArticlesSection />
        <MoreArticlesGrid />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}